import React, { useState } from "react";
import BarraNavegacion from "../components/BarraNavegacion";
import Footer from "../components/Footer";
import { Alert, Button, Container, Form } from "react-bootstrap";
import { db } from "../firebase-config";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function Contacto() {
  const [formData, setFormData] = useState({
    nombres: "",
    email: "",
    mensaje: "",
  });
  const [status, setStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    const payload = {
      nombres: sanitizeText(formData.nombres, 100),
      email: sanitizeText(formData.email, 180).toLowerCase(),
      mensaje: sanitizeText(formData.mensaje, 2000),
    };

    if (!payload.nombres || !EMAIL_REGEX.test(payload.email) || !payload.mensaje) {
      setStatus({
        type: "danger",
        message: "Revisa los datos antes de enviar el mensaje.",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      await addDoc(collection(db, "contacto"), {
        ...payload,
        createdAt: serverTimestamp(),
      });
      setStatus({
        type: "success",
        message: "El mensaje se ha enviado correctamente.",
      });
      setFormData({ nombres: "", email: "", mensaje: "" });
    } catch (error) {
      setStatus({
        type: "danger",
        message: "No se pudo enviar el mensaje. Intentalo de nuevo.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <BarraNavegacion title={"Necesitas ayuda?"} />
      <Container fluid className="vh-100">
        <Container className="mt-5 mb-5">
          {status && (
            <Alert
              variant={status.type}
              onClose={() => setStatus(null)}
              dismissible
            >
              {status.message}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="contacto-nombres">
              <Form.Control
                type="text"
                name="nombres"
                placeholder="Nombre y apellido"
                value={formData.nombres}
                maxLength={100}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="contacto-email">
              <Form.Control
                type="email"
                name="email"
                placeholder="Correo electronico"
                value={formData.email}
                maxLength={180}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="contacto-mensaje">
              <Form.Control
                as="textarea"
                name="mensaje"
                placeholder="Escribe tu mensaje"
                value={formData.mensaje}
                maxLength={2000}
                onChange={handleChange}
                required
                rows={3}
              />
            </Form.Group>
            <div className="d-grid gap-2">
              <Button type="submit" variant="dark" disabled={isSubmitting}>
                {isSubmitting ? "Enviando..." : "Enviar"}
              </Button>
            </div>
          </Form>
        </Container>
      </Container>
      <Footer />
    </>
  );
}

function sanitizeText(value, maxLength) {
  return String(value || "")
    .replace(/[\r\n]+/g, " ")
    .trim()
    .slice(0, maxLength);
}

export default Contacto;
